export default {
    apiKey: "AIzaSyCY0RKOLs6sDnUbppU9fVVU7anOKLw_TEQ",
    authDomain: "copack-app.firebaseapp.com",
    databaseURL: "https://copack-app.firebaseio.com",
    projectId: "copack-app",
    storageBucket: "copack-app.appspot.com",
    messagingSenderId: "500007841213",
    appId: "1:500007841213:web:847097d91278b8a03876d4",
    measurementId: "G-9Q42YD6Q52"
}